let keepActiveTimeout = 0;

export default function DeveloperTools() {
    let keepActiveTimer = 1000 * 60 * 10; // In milliseconds

    const initializeKeepActive = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const keepActive = urlParams.get('keep-active'); // Empty or minute value ?keep-active or ?keep-active=10
        const keepActiveWithoutValue = !keepActive && urlParams.has('keep-active');
        const enabled = keepActive || keepActiveWithoutValue;

        if (!keepActiveWithoutValue) {
            try {
                let parsedInt = parseInt(keepActive);
                if (!isNaN(parsedInt)) {
                    keepActiveTimer = parsedInt * 1000 * 60; // To milliseconds
                }
            }
            catch(err) {
                console.error(err);
            }
        }

        if (enabled) {
            console.log('Keeping active', `${keepActiveTimer/1000/60} minutes`);
            if (keepActiveTimeout) {
                clearTimeout(keepActiveTimeout);
            }

            keepActiveTimeout = setTimeout(() => {
                window.location.reload();
            }, keepActiveTimer);
        }
    }

    const __constructor = () => {
        initializeKeepActive();
    }

    __constructor();
}
